import * as types from './actionTypes';
import {FUNDING_APP_BASE_URL} from '../constants/global';
import {generateURL} from '../api/urlHelper';
import { authenticatedFetch } from '@forwardfinancing/component-library';

export function receivePortfolio(json) {
  return {type: types.RECEIVE_PORTFOLIO, portfolio: json.advances};
}

export function paginatePortfolio(json) {
  return {
    type: types.PAGINATE_PORTFOLIO,
    portfolioPagination: {
      totalPages: json.meta.total_pages,
      currentPage: json.meta.current_page
    }
  };
}

export function exportAndSavePortfolio(csv) {
  return {
    type: types.EXPORT_AND_SAVE_PORTFOLIO,
    data: csv
  };
}

export function fetchPortfolio(params = {}) {
  return dispatch => {
    return authenticatedFetch(portfolioURL(params), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(json => {
      dispatch(receivePortfolio(json));
      dispatch(paginatePortfolio(json));
      dispatch(handlePortfolioError(false));
    })
    .catch(() => {
      dispatch(handlePortfolioError(true));
    });
  };
}

export function handlePortfolioError(bool) {
  return {
    type: types.HANDLE_PORTFOLIO_ERROR,
    portfolioError: bool
  };
}

export function portfolioURL(params) {
  let url = `${FUNDING_APP_BASE_URL()}advances.json`;
  return generateURL(url, params);
}

export function exportPortfolio(params){
  return dispatch => {
    return authenticatedFetch(portfolioExportURL(params), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.text())
    .then(csv => {
      dispatch(exportAndSavePortfolio(csv));
    });
  };
}

export function portfolioExportURL(params) {
  let url = `${FUNDING_APP_BASE_URL()}advances.csv`;
  return generateURL(url, params);
}
